export const frontmatter = {"title":"Customization Provider"};
export const toc = [];